import { api } from './api'

export interface ApiKey {
  id: string
  label: string
  scopes: string[]
  request_rate_limit?: string | null
  created_at: string
  last_used_at?: string
  is_active: boolean
}

export interface CreateKeyResponse extends ApiKey {
  key: string
}

export async function listApiKeys(): Promise<ApiKey[]> {
  const res = await api.get('/v1/api-keys')
  return res.data
}

export async function createApiKey(label: string, scopes: string[]): Promise<CreateKeyResponse> {
  const res = await api.post('/v1/api-keys', { label, scopes })
  return res.data
}

export async function revokeApiKey(id: string): Promise<void> {
  await api.delete(`/v1/api-keys/${id}`)
}

export async function updateApiKey(id: string, body: Partial<Pick<ApiKey, 'label' | 'scopes' | 'request_rate_limit' | 'is_active'>>): Promise<ApiKey> {
  const res = await api.put(`/v1/api-keys/${id}`, body)
  return res.data
}
